import React, { createContext, useContext, useState, useEffect, useMemo } from 'react';
import { useAuth } from './AuthContext';
import { processAllData } from '../utils/dataParser';
import seedData from '../data/rawSheetsData.json';
import { useSelector } from 'react-redux';
import * as XLSX from "xlsx";
import { useSearchParams } from "react-router-dom";
import { LoadContext } from '../../../../ReusableComponents/LoadingContex';
import { calculateMasteryLevel, calculateLevelStats } from '../utils/calculations';
const DataContext = createContext(null);

export const DataProvider = ({ children }) => {
  const { branchLock } = useAuth();
  const [loading, setLoading] = useState(true);
  const [syncing, setSyncing] = useState(false);
  const [syncStatus, setSyncStatus] = useState('idle'); // 'idle' | 'syncing' | 'success' | 'failed'
  const [lastSyncTime, setLastSyncTime] = useState('');
  const USYear = useSelector((state) => state.SelecYearData.SYear);
  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const SelectDate = useSelector((state) => state.DateDetailsData.DateDetails);
  const { SetLoad } = useContext(LoadContext);

  const SchoolData = JSON.parse(localStorage.getItem("SDetails"));
  // Scoping filters
  const [currentBranchFilter, setCurrentBranchFilter] = useState('all');
  const [activeTab, setActiveTab] = useState('participation');

  // Parsed dataset structures
  const [dataset, setDataset] = useState({
    allStudentsData: [],
    schoolInfo: new Map(),
    loMap: new Map(),
    levelMap: new Map(),
    mathResults: new Map(),
    englishResults: new Map(),
    masterList: new Map(),
    participationCounts: [],
    participationDeatils: [],
  });
  // Pre-seed data on startup
  useEffect(() => {
    if (!SelectDate || !USYear || !items || SelectDate?.assessmentType !== 3) {
      return;
    }
    setDataset({
      allStudentsData: [],
      schoolInfo: new Map(),
      loMap: new Map(),
      levelMap: new Map(),
      mathResults: new Map(),
      englishResults: new Map(),
      masterList: new Map(),
      participationCounts: [],
      participationDeatils: [],
    });
    // syncWithGoogleSheets();
    ReadRegistrations();
    // ReadResponsess();
  }, [SelectDate, USYear, items]);
  // Update branch filter if user profile locks it
  // console.log("dataset", dataset);
  useEffect(() => {
    // if (branchLock) { setCurrentBranchFilter(branchLock); } 
    setCurrentBranchFilter(items?.userTypeId === 2 ? items?.schoolName?.trim() : SchoolData?.levelValue);
    // else { setCurrentBranchFilter('all'); }
  }, [branchLock]);

  // Scoped student fetch
  const getScopedStudents = () => {
    let list = dataset.allStudentsData;
    // if (branchLock) { return list.filter(s => s.school === branchLock); }
    // if (currentBranchFilter === 'all') { return list; }
    // return list.filter(s => s.school === currentBranchFilter);
    return list
  };


  const ReadRegistrations = async () => {
     SetLoad(true);
    let filepath;
    if (items.instituteId === 1 || items.instituteId === 3) {
      filepath = `/ExportStudents/${USYear.display}/${SelectDate.display}/Registrations/${SelectDate.display}_${items.instituteCode}_{SRSData?.display}_${SelectDate.examStartDate}_${items?.userTypeId === 2 ? items?.schoolName?.trim() : SchoolData?.levelValue}.xlsx`

    } else if (items.instituteId === 8 || items.instituteId === 9 || items.instituteId === 5) {
      // return [`/ExportStudents/${USYear.display}/${SelectDate.display}/Registrations/${SelectDate.display}_SSSO_${SelectDate.examStartDate}_${items?.userTypeId === 2 ? items?.schoolName?.trim() : SchoolData?.levelValue}.xlsx`]
      // filepath = `/ExportStudents/${USYear.display}/${SelectDate.display}/Registrations/${SelectDate.display}_${items?.userTypeId === 2 ? items.societyName : "SSSO"}_${SelectDate.examStartDate}_${items?.userTypeId === 2 ? items?.schoolName?.trim() : SchoolData?.levelValue}.xlsx`
      filepath = `/ExportStudents/${USYear.display}/${SelectDate.display}/Registrations/${SelectDate.display}_${items?.userTypeId === 2 ? items.societyName : items?.societyCode}_${SelectDate.examStartDate}_${items?.userTypeId === 2 ? items?.schoolName?.trim() : SchoolData?.levelValue}.xlsx`

    } else {
      filepath = `/ExportStudents/${USYear.display}/${SelectDate.display}/Registrations/${SelectDate.display}_${items.instituteCode}_${SelectDate.examStartDate}_${items?.userTypeId === 2 ? items?.schoolName?.trim() : SchoolData?.levelValue}.xlsx`
    }
    try {
      const response = await fetch(filepath);
      if (!response.ok) {
        throw new Error(`Unable to load master file: ${filepath}`);
      }
      const buffer = await response.arrayBuffer();
      // 4. Read Excel workbook
      const workbook = XLSX.read(buffer, { type: "array", });
      // console.log("Sheet Names:", workbook.SheetNames);
      // 5. Check that there are at least 2 sheets
      if (workbook.SheetNames.length < 2) {
        throw new Error("Excel file does not contain 2 sheets");
      }
      // 6. Get sheet names
      const sheet1Name = workbook.SheetNames[0];
      // 7. Get worksheets
      const sheet1 = workbook.Sheets[sheet1Name];
      const sheet1Rows = XLSX.utils.sheet_to_json(sheet1, { header: 1, defval: "", });
      const headerIndex1 = sheet1Rows.findIndex((row) =>
        row.some((value) => String(value).trim().toLowerCase() === "studentid"));
      if (headerIndex1 === -1) {
        throw new Error("Student header not found");
      }
      const header1 = sheet1Rows[headerIndex1];
      const snoIndex = header1.findIndex((value) => String(value).trim().toLowerCase() === "sno");
      const studentIdIndex = header1.findIndex((value) => String(value).trim().toLowerCase() === "studentid");
      const studentNameIndex = header1.findIndex((value) => String(value).trim().toLowerCase() === "student name");
      const dateOfBirthIndex = header1.findIndex((value) => String(value).trim().toLowerCase() === "dateofbirth");
      const gradeIndex1 = header1.findIndex((value) => String(value).trim().toLowerCase() === "grade");
      const genderIndex = header1.findIndex((value) => String(value).trim().toLowerCase() === "gender");
      const sectionIndex1 = header1.findIndex((value) => String(value).trim().toLowerCase() === "section");
      // const mediumIndex = header1.findIndex( (value) => String(value).trim().toLowerCase() === "medium of instruction" );
      // const languageIndex = header1.findIndex( (value) => String(value).trim().toLowerCase() === "language" );
      // const electiveSubjectIndex = header1.findIndex( (value) => String(value).trim().toLowerCase() === "elective subject" );
      const statusIndex = header1.findIndex((value) => String(value).trim().toLowerCase() === "status");

      const studentData = sheet1Rows
        .slice(headerIndex1 + 1)
        .filter((row) => row[studentIdIndex] !== "")
        .map((row) => ({
          id: String(row[studentIdIndex]),
          name: row[studentNameIndex],
          // dateOfBirth: row[dateOfBirthIndex],
          registeredGrade: row[gradeIndex1],
          gender: row[genderIndex],
          section: row[sectionIndex1],
          participated: row[statusIndex] === 0 ? false : true,
          // medium: row[mediumIndex],
          // language: row[languageIndex],
          // electiveSubject: row[electiveSubjectIndex],
          status: row[statusIndex] === 0 ? "Absent" : "Participated",
          school: items?.userTypeId === 2 ? items?.schoolName?.trim() : SchoolData?.levelValue,
        }));
      const sheet1Data = studentData.reduce((acc, row) => {
        const studentId = String(row.id || "").trim();
        if (studentId) {
          acc[studentId] = row;
        }
        return acc;
      }, {});
      const participationSheet = workbook.Sheets["Participation"];
      const participationRows = XLSX.utils.sheet_to_json(participationSheet, { header: 1, defval: "", });

      // Find header row
      const headerIndex = participationRows.findIndex((row) =>
        row.some((value) => String(value).trim().toLowerCase() === "grade"));

      if (headerIndex === -1) {
        throw new Error("Participation header not found");
      }

      const header = participationRows[headerIndex];
      const gradeIndex = header.findIndex((value) => String(value).trim().toLowerCase() === "grade");
      const sectionIndex = header.findIndex((value) => String(value).trim().toLowerCase() === "section");
      const registeredIndex = header.findIndex((value) => String(value).trim().toLowerCase() === "registered");
      const participatedIndex = header.findIndex((value) => String(value).trim().toLowerCase() === "participated");
      const absentIndex = header.findIndex((value) => String(value).trim().toLowerCase() === "absent");
      // Convert rows into objects
      const participationData = participationRows.slice(headerIndex + 1)
        .filter((row) => {
          return (
            row[gradeIndex] !== ""
            // && String(row[gradeIndex]).trim().toLowerCase() !== "total"
          );
        })
        .map((row) => ({
          Grade: row[gradeIndex],
          Section: row[sectionIndex],
          GradeSection: row[gradeIndex] + " - " + row[sectionIndex],
          Registered: row[registeredIndex],
          Participated: row[participatedIndex],
          Absent: row[absentIndex],

        }));

      const result = {
        RmasterList: sheet1Data,
        allStudentsData: studentData,
        participationCounts: participationData,
      };
      setDataset((prev) => ({
        ...prev,
        masterList: result.RmasterList,
        allStudentsData: [...result.allStudentsData],
        participationCounts: [...result.participationCounts,],
      }));
      // console.log("result", result);
 SetLoad(false);
      setTimeout(() => {
        ReadResponsess();
      }, 2000);
    } catch (error) { console.error("Error processing master file:", filepath, error); }
  }
  // Live synchronizer from Google Sheets endpoints
  const syncWithGoogleSheets = async () => {
    if (syncing) return;
    SetLoad(true);
    setSyncing(true);
    setSyncStatus('syncing');

    try {

      const freshRawData = await processAllFiles();
      // Map and process details
      const result = processAllData(freshRawData, items, SchoolData);
      // console.log("result", result)
      // setDataset(result);
      setDataset((prev) => ({
        ...prev,
        ...result,

        // Preserve previously loaded participation data
        participationDeatils: prev.participationDeatils,
        participationCounts: prev.participationCounts,
      }));
      setLastSyncTime(new Date().toLocaleTimeString());
      setSyncStatus('success');
    } catch (e) {
      console.error("Could not sync with live spreadsheet. Relying on pre-seeded backup data.", e);
      setSyncStatus('failed');
    } finally {
      setSyncing(false);
      SetLoad(false);
    }
  };

  const masterFiles = useMemo(() => {

    // Don't create file paths before SelectDate is available
    if (!SelectDate || !USYear || !items) { return []; }
    if (items.instituteId === 1 || items.instituteId === 3) {
      return [`/ExportStudents/${USYear.display}/${SelectDate.display}/Registrations/${SelectDate.display}_${items.instituteCode}_{SRSData?.display}_${SelectDate.examStartDate}_${items?.userTypeId === 2 ? items?.schoolName?.trim() : SchoolData?.levelValue}.xlsx`]

    } else if (items.instituteId === 8 || items.instituteId === 9 || items.instituteId === 5) {
      // return [`/ExportStudents/${USYear.display}/${SelectDate.display}/Registrations/${SelectDate.display}_SSSO_${SelectDate.examStartDate}_${items?.userTypeId === 2 ? items?.schoolName?.trim() : SchoolData?.levelValue}.xlsx`]
      return [`/ExportStudents/${USYear.display}/${SelectDate.display}/Registrations/${SelectDate.display}_${items?.userTypeId === 2 ? items.societyName : items?.societyCode}_${SelectDate.examStartDate}_${items?.userTypeId === 2 ? items?.schoolName?.trim() : SchoolData?.levelValue}.xlsx`]

    } else {
      return [`/ExportStudents/${USYear.display}/${SelectDate.display}/Registrations/${SelectDate.display}_${items.instituteCode}_${SelectDate.examStartDate}_${items?.userTypeId === 2 ? items?.schoolName?.trim() : SchoolData?.levelValue}.xlsx`]
    }
  }, [SelectDate, USYear, items]);



  const processMasterFiles = async (filepath) => {
    const output = {};
    // for (const filePath of filepath) {
    for (const filePath of masterFiles) {
      try {
        const response = await fetch(filePath);
        if (!response.ok) {
          throw new Error(`Unable to load master file: ${filePath}`);
        }
        const buffer = await response.arrayBuffer();
        const workbook = XLSX.read(buffer, { type: "array", });
        workbook.SheetNames.forEach((sheetName) => {
          const sheet = workbook.Sheets[sheetName];
          const rows = XLSX.utils.sheet_to_json(sheet, { header: 1, defval: "", });
          if (!rows.length) { return; }
          /* Find the actual master header
           *SNo, StudentId, Student Name, Gender, Date of Birth, Grade, Section, ...
           */
          const headerIndex = rows.findIndex((row) => {
            const normalizedRow = row.map((value) => String(value ?? "").trim().toLowerCase());
            return (
              normalizedRow.includes("sno") && normalizedRow.includes("studentid") &&
              normalizedRow.includes("student name") && normalizedRow.includes("grade")
            );
          });

          if (headerIndex === -1) {
            return;
          }
          /* Get header */
          const header = rows[headerIndex];
          /* Find required columns */
          const studentIdIndex = header.findIndex((value) => String(value ?? "").trim().toLowerCase() === "studentid");
          const studentNameIndex = header.findIndex((value) => String(value ?? "").trim().toLowerCase() === "student name");
          const gradeIndex = header.findIndex((value) => String(value ?? "").trim().toLowerCase() === "grade");
          /* Validate columns */
          if (studentIdIndex === -1 || studentNameIndex === -1 || gradeIndex === -1) {
            return;
          }
          /* Get student rows */
          const studentRows = rows.slice(headerIndex + 1).filter((row) => {
            const studentId = String(row[studentIdIndex] ?? "").trim();
            return studentId !== "";
          });

          if (!studentRows.length) {
            return;
          }
          /* Get school name
           * First row normally contains: SCHOOL NAME - Student Logins for NSF */
          let schoolName = "";
          const firstRowValue = String(rows[0]?.[0] ?? "").trim();
          if (firstRowValue) {
            schoolName = firstRowValue.replace(/\s*-\s*Student Logins for NSF\s*$/i, "").trim();
          }
          /* If school name couldn't be obtained,use sheet name.*/
          if (!schoolName) { schoolName = sheetName; }
          /* Create master key
           * Example:master_SRI SATHYA SAI VIDYA MANDIR DHARWAD */
          const key = `master_${schoolName}`;
          /* Convert original sheet to CSV */
          const csvData = XLSX.utils.sheet_to_csv(sheet);
          output[key] = csvData;
        });
      } catch (error) { console.error("Error processing master file:", filePath, error); }
    }
    return output;
  };

  const grades = useMemo(() => {
    if (!SelectDate) { return []; }
    return [
      ...new Set([...(SelectDate.grades_1_10 ? SelectDate.grades_1_10.split(",").map(Number) : []),
      ...(SelectDate.grades_11_12 ? SelectDate.grades_11_12.split(",").map(Number) : [])
      ])
    ]
  }, [SelectDate]);
  localStorage.setItem("AGrades", JSON.stringify(grades));

  const ReadResponsess = async () => {
    let filepaths;
    if (items.instituteId === 1 || items.instituteId === 3) {
      filepaths = grades.map((G) =>
        `/ExportStudents/${USYear.display}/${SelectDate.display}/${SelectDate.display}_${items.instituteCode}_{SRSData?.display}_${G}_${SelectDate.examStartDate}.xlsx`
      );

    } else if (items.instituteId === 8 || items.instituteId === 9 || items.instituteId === 5) {
      filepaths = grades.map((G) =>
        // `/ExportStudents/${USYear.display}/${SelectDate.display}/${SelectDate.display}_${items?.userTypeId === 2 ? items.societyName : "SSSO"}_${G}_${SelectDate.examStartDate}.xlsx`
        `/ExportStudents/${USYear.display}/${SelectDate.display}/${SelectDate.display}_${items?.userTypeId === 2 ? items.societyName?.replace("-", "") : items?.societyCode?.replace("-", "")}_${G}_${SelectDate.examStartDate}.xlsx`
        // `/ExportStudents/${USYear.display}/${SelectDate.display}/${SelectDate.display}_SSSO_${G}_${SelectDate.examStartDate}.xlsx`?.replace("-", "")
      );

    } else {
      filepaths = grades.map((G) =>
        `/ExportStudents/${USYear.display}/${SelectDate.display}/${SelectDate.display}_${items.instituteCode}_${G}_${SelectDate.examStartDate}.xlsx`
      );
    }

    const responseData = {
      mathResults: new Map(),
      englishResults: new Map()
    };
    const masterList = new Map();
    const schoolInfo = new Map();
    const mathResults = new Map();
    const englishResults = new Map();
    const loMap = new Map();
    const levelMap = new Map();
    const parseLevel = (raw) => {
      if (!raw) return NaN;
      const s = raw.trim().toLowerCase();
      if (s === 'pre-primary') return 0;
      const m = s.match(/(\d+)/);
      return m ? parseInt(m[1]) : NaN;
    };
console.log("filepaths",filepaths)
    for (const filepath of filepaths) {
      try {
        // console.log("Reading Response File:", filepath);
        const response = await fetch(filepath);
        console.log("response",response)
        if (!response.ok) {
          // console.warn("Response file not found:", filepath);
           throw new Error(`Unable to load ${filepath}`);
          // continue;
        }
        const buffer = await response.arrayBuffer();
        const workbook = XLSX.read(buffer, { type: "array" });
        // console.log("Response sheets:", workbook.SheetNames);
        /*
         * ---------------------------------------------
         * Process every sheet
         * ---------------------------------------------
         */
        workbook.SheetNames.forEach((sheetName) => {
          const sheet = workbook.Sheets[sheetName];
          const rows = XLSX.utils.sheet_to_json(sheet, { header: 1, defval: "" });
          if (rows.length < 6) {
            return;
          }
          /*
           * ---------------------------------------------
           * Same structure as processResponseCSV()
           * Header = row 1
           * Level  = row 3
           * LO     = row 4
           * Data   = row 5 onwards
           * ---------------------------------------------
           */
          const header = rows[1].map((h) => String(h ?? "").trim());
          const levelRow = rows[3];
          const loRow = rows[4];
          /*
           * ---------------------------------------------
           * Find column indexes
           * ---------------------------------------------
           */
          const idx = {
            schoolId: header.indexOf("SchoolId"),
            schoolName: header.indexOf("SchoolName"),
            district: header.indexOf("District"),
            grade: header.indexOf("Grade"),
            section: header.indexOf("Section"),
            loginId: header.indexOf("LoginId"),
            firstName: header.indexOf("FirstName"),
            lastName: header.indexOf("LastName")
          };
          /*
           * ---------------------------------------------
           * Find Q columns
           * ---------------------------------------------
           */
          const qCols = [];
          for (let c = 0; c < header.length; c++) {
            if (/^Q\d+$/.test(header[c])) {
              qCols.push(c);
            }
          }
          /*
           * ---------------------------------------------
           * Calculate levels and LOs
           * ---------------------------------------------
           */
          const levels = qCols.map((c) => parseLevel(levelRow[c]));
          const los = qCols.map((c) => String(loRow[c] ?? "").trim());
          /*
           * ---------------------------------------------
           * Determine subject from sheet name
           * ---------------------------------------------
           */
          let subject = "";
          const lowerSheetName = sheetName.toLowerCase();
          if (lowerSheetName.includes("english")) {
            subject = "English";
          } else if (
            lowerSheetName.includes("math") ||
            lowerSheetName.includes("maths") ||
            lowerSheetName.includes("mathematics")
          ) {
            subject = "Math";
          }
          /*
           * If subject cannot be determined,
           * skip sheet.
           */
          if (!subject) {
            // console.warn( "Subject not found:", sheetName );
            return;
          }
          /*
           * Select correct result map
           */
          const resultMap = subject === "Math" ? responseData.mathResults : responseData.englishResults;
          /*
           * ---------------------------------------------
           * Process every student
           * ---------------------------------------------
           */
          for (let r = 5; r < rows.length; r++) {
            const row = rows[r];
            if (!row || row.length === 0) {
              continue;
            }
            /*
             * Login ID
             */
            const loginId = String(row[idx.loginId] ?? "").trim();
            if (!loginId) {
              continue;
            }
            /*
             * ---------------------------------------------
             * Student information
             * ---------------------------------------------
             */
            const regGrade = parseInt(row[idx.grade]);
            const schoolId = String(row[idx.schoolId] ?? "").trim();
            const schoolName = String(row[idx.schoolName] ?? "").trim();
            const district = String(row[idx.district] ?? "").trim();
            /*
             * ---------------------------------------------
             * Backfill school information
             * ---------------------------------------------
             */
            if (schoolId && schoolName) {
              schoolInfo.set(schoolId, { name: schoolName, district: district || "Unknown" });
            }
            /*
             * ---------------------------------------------
             * Assessed grade filter
             * ---------------------------------------------
             */
            if (!isNaN(regGrade) && !grades.includes(regGrade)) {
              continue;
            }
            /*
             * ---------------------------------------------
             * School filter
             * ---------------------------------------------
             */
            if (schoolName !== (items?.userTypeId === 2 ? items?.schoolName?.trim() : SchoolData?.levelValue)) {
              continue;
            }
            /*
             * ---------------------------------------------
             * DO NOT create a new student here
             * Registration is already loaded.
             * We only need response data.
             * ---------------------------------------------
             */

            /*
             * ---------------------------------------------
             * Convert answers
             * Same logic as processResponseCSV()
             * ---------------------------------------------
             */
            const answers =
              qCols.map((c) => {
                const raw = row[c];
                return (raw === "" || raw === undefined || raw === null)
                  ? NaN : parseInt(raw === "U" ? 0 : raw);
              });
            /*
             * ---------------------------------------------
             * Calculate mastery
             * ---------------------------------------------
             */
            console.log("hit");
            const masteryLevel = calculateMasteryLevel(answers, levels, regGrade);
            /*
             * ---------------------------------------------
             * Store EXACT SAME FORMAT
             * This is the same structure as:
             * resultMap.set(loginId, {
             *   answers,
             *   levels,
             *   masteryLevel,
             *   stats
             * })
             * ---------------------------------------------
             */

            resultMap.set(loginId,
              {
                answers, levels, masteryLevel,
                stats: calculateLevelStats(answers, levels)
              }
            );
            /*
             * ---------------------------------------------
             * Build LO and Level maps
             * ---------------------------------------------
             */
            const studentGrade = isNaN(regGrade) ? null : regGrade;
            if (studentGrade) {
              qCols.forEach((c, qi) => {
                /*
                 * LO
                 */
                if (los[qi]) {
                  loMap.set(`${subject}-${studentGrade}-${qi + 1}`, los[qi]);
                }

                /*
                 * Level
                 */
                if (!isNaN(levels[qi])) {
                  levelMap.set(`${subject}-${studentGrade}-${qi + 1}`, levels[qi]);
                }
              }
              );
            }
          }
        });
      } catch (error) {
        /*
         * If one grade file fails,
         * continue with remaining files.
         */
        console.error("Error reading response file:", filepath, error);
      }
    }
    /*
     * ---------------------------------------------
     * Merge response results into existing dataset
     * ---------------------------------------------
     */
    setDataset((prev) => {
      /*
       * Existing registration students
       *
       * Keep the SAME student object format.
       */
      const updatedStudents =
        prev.allStudentsData.map(
          (student) => {
            const studentId = String(student.id ?? "").trim();
            const mathData = responseData.mathResults.get(studentId);
            const englishData = responseData.englishResults.get(studentId);
            /*
             * No response found
             */
            if (!mathData && !englishData) {
              return student;
            }
            /*
             * -----------------------------------------
             * Calculate scores
             * -----------------------------------------
             */
            const mathAnswers = mathData?.answers || [];
            const englishAnswers = englishData?.answers || [];

            const countCorrect = (list) => list.filter((v) => v === 1).length;
            const countAttempted = (list) => list.filter((v) => !isNaN(v)).length;

            const mathCorrect = countCorrect(mathAnswers);
            const mathAttempted = countAttempted(mathAnswers);

            const englishCorrect = countCorrect(englishAnswers);
            const englishAttempted = countAttempted(englishAnswers);
            const totalAttempted = mathAttempted + englishAttempted;
            const scorePercentage = totalAttempted > 0 ? ((mathCorrect + englishCorrect) / totalAttempted) * 100 : 0;

            /*
             * Mastery
             */
            let mathMastery = mathData?.masteryLevel || 0;
            let englishMastery = englishData?.masteryLevel || 0;
            /*
             * Existing registration grade
             */
            const registeredGrade = student.registeredGrade;

            /*
             * Grade 1 custom logic
             */
            if (registeredGrade === 1) {
              if (mathMastery === 2) {
                mathMastery = 1;
              }
              if (englishMastery === 2) {
                englishMastery = 1;
              }
            }

            /*
             * -----------------------------------------
             * Return SAME allStudentsData format
             * -----------------------------------------
             */
            return {
              ...student,
              participated: true,
              status: "Participated",
              mathMastery,
              englishMastery,
              mathScore: mathAttempted > 0 ? (mathCorrect / mathAttempted) * 100 : 0,
              englishScore: englishAttempted > 0 ? (englishCorrect / englishAttempted) * 100 : 0,
              mathCorrect,
              mathAttempted,
              englishCorrect,
              englishAttempted,
              totalCorrect: mathCorrect + englishCorrect,
              totalAttempted,
              mathStats: mathData?.stats || {},
              englishStats: englishData?.stats || {},
              scorePercentage
            };
          }
        );
      const Rresults = {
        ...prev,
        allStudentsData: updatedStudents,
        mathResults: responseData.mathResults,
        englishResults: responseData.englishResults,
        schoolInfo,
        loMap,
        levelMap
      };
      // console.log("Response reading completed", Rresults);
      return Rresults;
    });

    // console.log("Response reading completed");
  }
  const excelFiles = useMemo(() => {

    // Don't create file paths before SelectDate is available
    if (!SelectDate || !USYear || !items || grades.length === 0) { return []; }

    if (items.instituteId === 1 || items.instituteId === 3) {
      return grades.map((G) =>
        `/ExportStudents/${USYear.display}/${SelectDate.display}/${SelectDate.display}_${items.instituteCode}_{SRSData?.display}_${G}_${SelectDate.examStartDate}.xlsx`
      );

    } else if (items.instituteId === 8 || items.instituteId === 9 || items.instituteId === 5) {
      return grades.map((G) =>
        `/ExportStudents/${USYear.display}/${SelectDate.display}/${SelectDate.display}_${items?.userTypeId === 2 ? items.societyName : items?.societyCode?.replace("-", "")}_${G}_${SelectDate.examStartDate}.xlsx`
        // `/ExportStudents/${USYear.display}/${SelectDate.display}/${SelectDate.display}_SSSO_${G}_${SelectDate.examStartDate}.xlsx`?.replace("-", "")
      );

    } else {
      return grades.map((G) =>
        `/ExportStudents/${USYear.display}/${SelectDate.display}/${SelectDate.display}_${items.instituteCode}_${G}_${SelectDate.examStartDate}.xlsx`
      );
    }
  }, [SelectDate, USYear, items, grades]);

  const processFiles = async () => {
    const output = {};

    for (const filePath of excelFiles) {
      try {
        const response = await fetch(filePath);
        if (!response.ok) {
          throw new Error(`Unable to load ${filePath}`);
        }
        const buffer = await response.arrayBuffer();
        const workbook = XLSX.read(buffer, { type: "array", });
        /* Process every sheet in the workbook */
        workbook.SheetNames.forEach((sheetName) => {
          const sheet = workbook.Sheets[sheetName];

          /* -----------------------------------------
           * Get Grade and Subject from sheet name
           * -----------------------------------------
           */

          const lowerSheetName = sheetName.toLowerCase();
          let grade = "";
          let subject = "";
          /* Find grade
           * Supports:
           * Grade 3
           * Grade3
           * grade_3
           * grade-3 */

          const gradeMatch = lowerSheetName.match(/grade[\s_-]*(\d+)/);
          if (gradeMatch) { grade = gradeMatch[1]; }
          /* Find subject */
          if (lowerSheetName.includes("english")) {
            subject = "english";
          } else if (lowerSheetName.includes("math") || lowerSheetName.includes("maths") || lowerSheetName.includes("mathematics")) {
            subject = "math";
          }
          /*If grade or subject cannot be found, skip this sheet. */

          if (!grade || !subject) {
            // console.warn( "Grade or subject not found:", sheetName );
            return;
          }

          const rows = XLSX.utils.sheet_to_json(sheet, { defval: "" });

          const mappedRows = rows.map(r => ({
            SNo: r["KGBV - Student Responses Data Sheet - 07 Aug 2026 -  Samagra 1"],
            SchoolId: r["__EMPTY"],
            SchoolName: r["__EMPTY_1"],
            District: r["__EMPTY_2"],
            Grade: r["__EMPTY_3"],
            LoginId: r["__EMPTY_4"],
            FirstName: r["__EMPTY_5"],
            LastName: r["__EMPTY_6"],
            Q1: r["__EMPTY_7"],
            Q2: r["__EMPTY_8"],
            Q3: r["__EMPTY_9"],
            Q4: r["__EMPTY_10"],
            Q5: r["__EMPTY_11"],
            Q6: r["__EMPTY_12"],
            Q7: r["__EMPTY_13"],
            Q8: r["__EMPTY_14"],
            Q9: r["__EMPTY_15"],
            Q10: r["__EMPTY_16"],
            Q11: r["__EMPTY_17"],
            Q12: r["__EMPTY_18"],
            Q13: r["__EMPTY_19"],
            Q14: r["__EMPTY_20"],
            Q15: r["__EMPTY_21"],
            Q16: r["__EMPTY_22"],
            Q17: r["__EMPTY_23"],
            Q18: r["__EMPTY_24"],
            Q19: r["__EMPTY_25"],
            Q20: r["__EMPTY_26"],
          }));
          const filtered = mappedRows.filter(
            (row, index) => {
              if (index > 3) {
                return row.SchoolName === (items?.userTypeId === 2 ? items?.schoolName?.trim() : SchoolData?.levelValue);
              }
              return true;
            }
          );
          /*
           * -----------------------------------------
           * Convert sheet to CSV
           * -----------------------------------------
           */
          const csvData = XLSX.utils.sheet_to_csv(XLSX.utils.json_to_sheet(filtered));
          // const csvData = XLSX.utils.sheet_to_csv(filtered);


          // console.log("csvData",csvData);
          // XLSX.utils.sheet_to_csv(filteredSheet);
          /*
           * -----------------------------------------
           * Create final key
           * -----------------------------------------
           * Example: response_grade3_english, response_grade3_math
           * response_grade4_english, response_grade4_math
           */
          const key = `response_grade${grade}_${subject}`;
          /* Store CSV data */
          output[key] = csvData;
        });
      } catch (error) {
        console.error("Error processing file:", filePath, error);
      }
    }
    console.log("output", output);
    /*
     * -----------------------------------------
     * Final result
     * -----------------------------------------
     */
    return (output);
  };

  const processAllFiles = async () => {
    const responseData = await processFiles();
    const masterData = await processMasterFiles();
    // const finalData = { ...responseData };
    const finalData = { ...responseData, ...masterData, };
    // console.log("finalData", finalData);
    return (finalData);
  };

  return (
    <DataContext.Provider value={{
      loading,
      syncing,
      syncStatus,
      lastSyncTime,
      currentBranchFilter,
      setCurrentBranchFilter,
      activeTab,
      setActiveTab,
      allStudentsData: dataset.allStudentsData,
      schoolInfo: dataset.schoolInfo,
      loMap: dataset.loMap,
      levelMap: dataset.levelMap,
      mathResults: dataset.mathResults,
      englishResults: dataset.englishResults,
      getScopedStudents,
      syncWithGoogleSheets,
      participationCounts: dataset.participationCounts,
      masterList: dataset?.masterList
      // injectFictionalSchoolData
    }}>
      {children}
    </DataContext.Provider>
  );
};

export const useData = () => useContext(DataContext);
